import { buildLoader } from '../util/GenericLoader';
import fetchBuildingsActionCreator from '../../redux/actions/buildings';

export default buildLoader(fetchBuildingsActionCreator);
